import { createContext, useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export default AuthContext

export const AuthProvider = ({children}) => {

    // when I use the function that means it will be used once on the initial not in every time 
    let [authTokens, setAuthTokens] = useState(() => localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
    // Check token.access in the next line
    let [user, setUser] = useState(() => localStorage.getItem('authTokens') ? jwtDecode(localStorage.getItem('authTokens')) : null)
    let [loading, setLoading] = useState(true)

    const navigate = useNavigate()

    const baseURL = "http://hamsieexpenses.com"
    // const baseURL = "http://hamsieexpenses.com"


    let loginUser = async (e) => {
        e.preventDefault()
        let response = await fetch(baseURL + '/api/token/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body:JSON.stringify({'username': e.target.username.value, 'password': e.target.password.value})
        })
        let data = await response.json()
        
        if(response.status === 200) {
            setAuthTokens(data)
            setUser(jwtDecode(data.access))
            localStorage.setItem('authTokens', JSON.stringify(data))
            // let currentUser = jwtDecode(data.access)
            // if (currentUser && currentUser.user_id === 1) {
            //     navigate('/')
            // } else {
            //     alert("something is wrong")
            // }
            navigate('/')
        } else {
            alert('Something went wrong');
        }
    }


    let registerUser = async (e) => {
        e.preventDefault()
        let response = await fetch(baseURL + '/api/register/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body:JSON.stringify({'username': e.target.username.value, 'email': e.target.email.value, 'first_name': e.target.first_name.value, 'last_name': e.target.last_name.value, 'password': e.target.password.value, 'company': e.target.company.value})
        })
        let data = await response.json()
        
        if(response.status === 200) {
            navigate('/login')
        } else {
            alert('Something went wrong');
        }
    }

    let logoutUser = () => {
        setAuthTokens(null)
        setUser(null)
        localStorage.removeItem('authTokens')
        navigate('/login')
    }


    // let updateToken = async () => {
    //     console.log("Update Token Called")
    //     let response = await fetch('http://hamsieexpenses.com/api/token/refresh/', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body:JSON.stringify({'refresh': authTokens?.refresh})
    //     })
    //     let data = await response.json()

    //     if (response.status === 200) {
    //         setAuthTokens(data)
    //         setUser(jwtDecode(data.access))
    //         localStorage.setItem('authTokens', JSON.stringify(data))
    //     } else {
    //         logoutUser()
    //     }

    //     if (loading) {
    //         setLoading(false)
    //     }
    // }


    let contextData = {
        user: user,
        authTokens: authTokens,
        loginUser: loginUser,
        logoutUser: logoutUser,
        setAuthTokens: setAuthTokens,
        setUser: setUser,
        registerUser: registerUser,
    }

    // useEffect is used for our lifecycle component
    useEffect(() => {

        if (authTokens) {
            setUser(jwtDecode(authTokens.access))
        }
        setLoading(false)
        // if (loading) {
        //     updateToken()
        // }

        // let fourMinutes = 1000 * 60 * 4
        // let interval = setInterval(() => {
        //     if (authTokens) {
        //         updateToken()
        //     }
        // }, fourMinutes)
        // return () => clearInterval(interval)
    }, [authTokens, loading])

    return (
        <AuthContext.Provider value={contextData}>
            {loading ? null : children}
        </AuthContext.Provider>
    )
}